// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const getSwiperSlides = (images) => {
    let content = [];
    for (let image of images) {
        content.push(
            <SwiperSlide>
                {" "}
                <img className="max-h-80 mx-auto" alt="" src={image} />
            </SwiperSlide>
        );
    }
    return content;
};

const Section = ({ brief, solution, bgCol, txtCol, slides }) => {
    return (
        <div className={`${bgCol} ${txtCol}`}>
            <div className="text-center p-0 max-w-3xl mx-auto">
                <div className="p-5">
                    <h2 className="font-bold text-5xl p-3">Brief</h2>
                    <p className="text-xl">{brief}</p>
                </div>
                <div className="p-5">
                    <h2 className="font-bold text-5xl  p-3">Solution</h2>
                    <p className="text-xl">{solution}</p>
                </div>
                <div className="p-10">
                    <Swiper
                        // install Swiper modules
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        autoHeight={true}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                        onSwiper={(swiper) => console.log(swiper)}
                        onSlideChange={() => console.log("slide change")}
                    >
                        {getSwiperSlides(slides)}
                    </Swiper>
                </div>
            </div>
        </div>
    );
};

export default Section;
